import { render } from "./testCom.vue?vue&type=template&id=108e3e64"
import script from "./testCom.vue?vue&type=script&lang=js"
export * from "./testCom.vue?vue&type=script&lang=js"

import "./testCom.vue?vue&type=style&index=0&id=108e3e64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__